import { LokiObjectType, LokiValue } from '../../../types';

export const defaultLokiValue: LokiValue = {
  ENV: 'NODEJS',
  autosave: true,
  autosaveHandle: null,
  autosaveInterval: 500,
  collections: [
    {
      DynamicViews: [],
      adaptiveBinaryIndices: true,
      asyncListeners: false,
      autoupdate: false,
      binaryIndices: {},
      cachedBinaryIndex: null,
      cachedData: null,
      cachedIndex: null,
      changes: [],
      cloneMethod: 'parse-stringify',
      cloneObjects: false,
      constraints: null,
      data: [],
      dirty: false,
      dirtyIds: [],
      disableChangesApi: true,
      disableDeltaChangesApi: true,
      disableFreeze: true,
      disableMeta: false,
      events: {
        close: [],
        delete: [
          null
        ],
        error: [],
        flushbuffer: [],
        insert: [],
        'pre-insert': [],
        'pre-update': [],
        update: [],
        warning: [
          null
        ]
      },
      idIndex: null,
      isIncremental: false,
      maxId: 0,
      name: LokiObjectType.serializedDesigns,
      objType: LokiObjectType.serializedDesigns,
      serializableIndices: true,
      transactional: false,
      transforms: {},
      ttl: null,
      uniqueNames: []
    }
  ],
  databaseVersion: 1.5,
  engineVersion: 1.5,
  events: {
    changes: [],
    close: [],
    flushChanges: [],
    init: [
      null
    ],
    loaded: [],
    warning: []
  },
  filename: 'appStore',
  isIncremental: false,
  options: {
    adapter: null,
    autosave: true,
    autosaveInterval: 500,
    destructureDelimiter: '$<\n',
    serializationMethod: 'normal'
  },
  persistenceAdapter: null,
  persistenceMethod: 'adapter',
  throttledSaves: true,
  verbose: false
};
